/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Watch, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './malfunctionStation.less';
import IndexPageApi, { IndexPageDOI } from '../api/IndexPage';
import TextMarquee from 'src/components/textMarquee/textMarquee';
import LocalStore from 'src/util/LocalStore';
let bem = createBEM('malfunction-station');

let map = {
    '0': '无告警',
    '1': '缺试剂告警',
    '2': '缺水样告警',
    '3': '缺蒸馏水告警',
    '4': '缺标液告警',
    '5': '仪表漏液告警',
    '6': '标定异常告警',
    '7': '超量程告警',
    '8': '加热异常',
    '9': '低试剂预警',
    '10': '超上限告警',
    '11': '超下限告警',
    '12': '仪表内部其它异常',
    '13': '滴定异常告警',
    '14': '电极异常告警',
    '15': '量程切换告警',
    '16': '参数设置告警',
    '17': 'PH电极电位异常',
    '18': '电导率电极异常',
    '19': '浊度光度异常',
    '20': '溶解氧电极异常',
    '21': '溶解氧光强异常',
};

@Component
export default class MalfunctionStation extends Vue.Component<any> {
    @Prop({
        type: Number,
    })
    type!: number;

    @Prop({
        type: Number,
        default: 15000,
    })
    time!: number;

    totalCount = 0;
    currentPage = 1;
    rows: IndexPageDOI.MalfunctionStationRowI[] = [];
    itv;
    imgReady: boolean = false;
    scale = 1;

    @Watch('type')
    typeChange() {
        this.currentPage = 1;
        clearInterval(this.itv);
        this.search();
        this.startInterver();
    }

    async search() {
        let t = this;
        let { code, data } = await IndexPageApi.searchMalfunctionStation(this.type, this.currentPage, 5);
        if (code === 0) {
            this.rows = data.data_info;
            this.totalCount = data.page_count;
            let img = new Image();
            img.src = require('../../../assets/images/mainPage-icon1.png');
            img.onload = function() {
                setTimeout(() => {
                    t.imgReady = true;
                });
            };
            var  userInfo = LocalStore.getData('userInfo');
            if(userInfo.username == "18931587700" || userInfo.username == "13933337316" || 
               userInfo.username == "15733997995" || userInfo.username == "18631518268" ||
               userInfo.username == "15733997329" || userInfo.username == "18131503382" ||
               userInfo.username == "18631589983" || userInfo.username == "15733997527"){
                this.rows = [];
            }
        }
    }
    startInterver() {
        this.itv = setInterval(() => {
            if ((this.currentPage - 1) * 5 + this.rows.length >= this.totalCount) {
                this.currentPage = 1;
            } else {
                this.currentPage++;
            }
            this.search();
        }, this.time);
    }
    mounted() {
        let t = this;
        this.search();
        let dom = this.$refs.content as any;
        let width = dom.offsetWidth;
        let height = dom.offsetHeight;
        this.scale = Math.min(width / 415, height / 280);

        // this.startInterver();
    }
    beforeDestroy() {
        // clearInterval(this.itv);
    }
    renderItem(h, item: IndexPageDOI.MalfunctionStationRowI) {
        return (
            <div class={bem('info-item')}>
                <div class={bem('info-item-info')}>
                    <div class={bem('info-component')}>{item.component}</div>
                    <div class={bem('info-mal')}>
                        <TextMarquee>{map[item['i12031-Info']]==undefined?"仪表其他异常":map[item['i12031-Info']]}</TextMarquee>
                    </div>
                    <div v-if={this.imgReady} class={bem('info-name')}>
                        <TextMarquee>{item.device_name}</TextMarquee>
                    </div>
                </div>
                <img width="113" height="130" src={require('../../../assets/images/mainPage-icon1.png')} />
            </div>
        );
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>故障站点</div>
                <div ref="content" class={bem('content')}>
                    <div class={bem('container')} style={{ transform: `translate(-50%, -50%) scale(${this.scale})` }}>
                        <div>
                            {this.rows.slice(0, 3).map(i => {
                                return this.renderItem(h, i);
                            })}
                        </div>
                        <div>
                            {this.rows.slice(-2).map(i => {
                                return this.renderItem(h, i);
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
